import { supabase } from '@/integrations/supabase/client';
import { OrdemServico } from '@/types';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function buildOrdemServicoUpsertRow(
  apiData: any,
  ordemServico: OrdemServico,
  clienteCadastroId: string | null
): Record<string, unknown> {
  const produtoParaSalvar =
    ordemServico.produto && ordemServico.produto !== 'Produto não informado'
      ? ordemServico.produto
      : null;

  const mergedApi = (ordemServico.api_data || apiData) as Record<string, unknown>;
  const mergedEmpresa = mergedApi.empresa as { id?: unknown; nome?: string } | undefined;
  const empresaIdSalvar =
    (mergedApi.empresa_id as number | string | undefined) ?? mergedEmpresa?.id ?? (apiData as any).empresa?.id;
  const empresaNomeSalvar =
    ordemServico.cliente || mergedEmpresa?.nome || (apiData as any).empresa?.nome || null;

  return {
    numero: ordemServico.numero,
    empresa_id: empresaIdSalvar,
    empresa_nome: empresaNomeSalvar,
    cliente_cadastro_id: clienteCadastroId,
    produto: produtoParaSalvar,
    data_real: apiData.data?.real,
    hora_inicio: apiData.horaInicio,
    hora_fim: apiData.horaFim,
    horas_totais: apiData.horasTotais,
    horas_faturadas: apiData.horasFaturadas,
    valor_faturamento: ordemServico.valorFaturamento,
    imposto: ordemServico.imposto,
    valor_a_pagar: ordemServico.valorAPagar,
    operador_id: apiData.operador?.id,
    operador_nome: apiData.operador?.nome,
    incluido: apiData.incluido,
    intervalo: apiData.intervalo,
    status_id: apiData.status?.id,
    status_descricao: apiData.status?.descricao,
    status_cor: apiData.status?.cor,
    projeto_id: apiData.projeto?.id,
    projeto_nome: apiData.projeto?.nome,
    projeto_fechado: apiData.projeto?.fechado,
    natureza_id: apiData.natureza?.id,
    natureza_descricao: apiData.natureza?.descricao,
    chamado_id: apiData.chamado?.id,
    chamado_descricao: apiData.chamado?.descricao,
    chamado_status_id: apiData.chamado?.status?.id,
    chamado_status_descricao: apiData.chamado?.status?.descricao,
    tempo_estimado_chamado: apiData.tempoEstimadoChamado,
    colaborador: apiData.colaborador,
    regime_contratacao: apiData.regimeContratacao,
    tipo_chamado: ordemServico.tipoChamado,
    api_data: ordemServico.api_data ?? apiData,
  };
}

export async function upsertOrdensServicoRows(
  rows: Record<string, unknown>[],
  chunkSize = 400
): Promise<void> {
  for (let i = 0; i < rows.length; i += chunkSize) {
    const chunk = rows.slice(i, i + chunkSize);
    const { error } = await supabase.from('ordens_servico').upsert(chunk, {
      onConflict: 'numero',
    });
    if (error) throw error;
  }
}

export const saveOrdemServicoToDatabase = async (apiData: any, ordemServico: OrdemServico) => {
  try {
    let clienteCadastroId = null;
    const nomeBusca = ordemServico.cliente || apiData.empresa?.nome;
    if (nomeBusca) {
      const { data: clienteData, error: clienteError } = await supabase
        .from('clientes_cadastro')
        .select('id')
        .eq('nome', nomeBusca)
        .maybeSingle();

      if (!clienteError && clienteData) {
        clienteCadastroId = clienteData.id;
      }
    }

    const row = buildOrdemServicoUpsertRow(apiData, ordemServico, clienteCadastroId);
    const { error } = await supabase
      .from('ordens_servico')
      .upsert(row, { onConflict: 'numero' });

    if (error) throw error;
  } catch (error) {
    throw error;
  }
};
